const digest = 'af3726b5626a5d18d3fa10418fe6c2173059dc507f788de496887406aeaf945d';
const css = `._popup_1wk8z_1{z-index:100}._popup_1wk8z_1>div>div{border-radius:0;height:100%;margin:0;max-height:unset;max-width:unset!important;width:100%}._popup_1wk8z_1>div>div>div{border-radius:0;height:100%;max-height:unset!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'popup': '_popup_1wk8z_1' };
export const popup = '_popup_1wk8z_1';
export { css, digest };